import React, { useState } from 'react';
import './FAQ.css';
import { Globals } from '../../global/Globals';

const FaqComponent = ({ data }) => {
    const [activeIndexes, setActiveIndexes] = useState({});

    const handleToggle = (category, index) => {
        setActiveIndexes(prevState => ({
            ...prevState,
            [category]: {
                ...prevState[category],
                [index]: !prevState[category]?.[index]
            }
        }));
    };

    const groupedQuestions = data.reduce((acc, item) => {
        if (!acc[item.category]) {
            acc[item.category] = [];
        }
        acc[item.category].push(item);
        return acc;
    }, {});

    const renderQuestions = (category, questions) => (
        questions.map((item, index) => (
            <div className="subHeader" key={index}>
                <div
                    draggable
                    onDragStart={(e) => e.preventDefault()}
                    onClick={() => handleToggle(category, index)}
                >
                    <img 
                        src={activeIndexes[category]?.[index] ? Globals.IMG.FAQ_UP_ARROW : Globals.IMG.FAQ_DOWN_ARROW} 
                        alt="toggle icon" 
                        className="faq-icon" 
                    />
                    <p className="sub-header">{item.question}</p>
                </div>
                {activeIndexes[category]?.[index] && (
                    <div className="para" dangerouslySetInnerHTML={{ __html: item.answer }} />
                )}
                {index < questions.length - 1 && <hr style={{ margin: "0rem" }} />} {/* Only add <hr> if it's not the last item in the category */}
            </div>
        ))
    );

    return (
        <div className="faq-wrapper">
            {Object.keys(groupedQuestions).map((category, catIndex, catArray) => (
                <div key={category}>
                    <div className="faq-header">{category}</div>
                    {renderQuestions(category, groupedQuestions[category])}
                    <hr style={{ display: catIndex < catArray.length - 1 ? "" : "none", margin: "0rem" }} />
                </div>
            ))}
        </div>
    );
};

export default FaqComponent;
